import { Link } from 'react-router-dom';
import { SEO } from '../components/common/SEO';
import { Layout } from '../components/common/Layout';
import { businessInfo } from '../utils/businessInfo';

const prohibitedContent = [
    'Harassment, bullying, threats, hate speech, or abusive behavior',
    'Sexual, exploitative, violent, dangerous, or illegal content',
    'Child exploitation, grooming, or any content that harms minors',
    'Spam, scams, impersonation, misleading activity, or fake engagement',
    'Content that infringes copyright, trademarks, privacy, or other rights',
];

const safetyTools = [
    'Users can report objectionable content from content surfaces in the app.',
    'Users can report or block abusive users from profile and interaction screens.',
    'Reported content is reviewed through automated safety checks and human moderation.',
    'Valid safety reports are acted on within 24 hours, including content removal and account suspension or termination where appropriate.',
];

export const CommunityGuidelinesPage: React.FC = () => {
    return (
        <Layout>
            <SEO
                title="Community Guidelines - Swag Shots"
                description="Swag Shots Community Guidelines explain our no-tolerance policy for objectionable content, reporting, blocking, and moderation."
                url="https://www.swagshots.com/community-guidelines"
            />

            <div className="pt-24 pb-16">
                <div className="container-custom max-w-4xl">
                    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8 md:p-12">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">Community Guidelines</h1>
                        <p className="text-gray-600 mb-8">Effective Date: January 1, 2025</p>

                        <div className="space-y-8">
                            <section className="space-y-4">
                                <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-primary-600 pb-2">
                                    1. No Tolerance for Abuse
                                </h2>
                                <p className="text-gray-700 leading-relaxed">
                                    Swag Shots does not tolerate objectionable content or abusive users. Users who post harmful content, harass others, or misuse the service may have content removed and accounts suspended or terminated.
                                </p>
                            </section>

                            <section className="space-y-4">
                                <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-primary-600 pb-2">
                                    2. Prohibited Content and Conduct
                                </h2>
                                <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                                    <ul className="space-y-3">
                                        {prohibitedContent.map((item) => (
                                            <li key={item} className="text-gray-700 flex items-start">
                                                <span className="text-red-600 mr-3 mt-1">-</span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-primary-600 pb-2">
                                    3. Reporting, Blocking, and Moderation
                                </h2>
                                <div className="bg-primary-50 border border-primary-200 rounded-lg p-6">
                                    <ul className="space-y-3">
                                        {safetyTools.map((item) => (
                                            <li key={item} className="text-gray-700 flex items-start">
                                                <span className="text-primary-600 mr-3 mt-1">-</span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-primary-600 pb-2">
                                    4. Appeals and Contact
                                </h2>
                                <p className="text-gray-700 leading-relaxed">
                                    Users may contact us about safety reports, moderation decisions, copyright concerns, or account actions at{' '}
                                    <a href={`mailto:${businessInfo.email}`} className="text-primary-600 hover:text-primary-700 underline font-semibold">
                                        {businessInfo.email}
                                    </a>.
                                </p>
                            </section>
                        </div>

                        <div className="text-center mt-8">
                            <Link
                                to="/terms"
                                className="inline-block bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors"
                            >
                                Back to Terms
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
